import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

const COUNTDOWN_SECONDS = 5;

@Component({
  selector: 'app-session-expired-modal',
  templateUrl: './session-expired-modal.component.html',
  styleUrls: ['./session-expired-modal.component.scss']
})
export class SessionExpiredModalComponent implements OnInit, OnDestroy {
  secondsLeft = COUNTDOWN_SECONDS;
  private intervalId: any;

  constructor(public dialogRef: MatDialogRef<SessionExpiredModalComponent>) { }

  ngOnInit(): void {
    this.intervalId = setInterval(() => {
      this.secondsLeft--;
      if (this.secondsLeft <= 0) {
        this.close();
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }

  close(): void {
    this.dialogRef.close();
  }
}
